<nz-form-item [formGroup]="formGroup()">
	<nz-form-label [nzSpan]="7" [nzRequired]="required()">
		{{ label() }}
	</nz-form-label>

	<nz-form-control [nzSpan]="12" nzHasFeedback nzValidatingTip="Validating..." [nzErrorTip]="errorTpl">
		<nz-select [formControlName]="controlName()" [nzPlaceHolder]="placeholder()" nzAllowClear nzShowSearch>
			@for (opt of options(); track opt.value) {
				<nz-option [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
			}
		</nz-select>

		<ng-template #errorTpl let-control>
			@if (control.errors?.['required']) {
				This field is required
			}
		</ng-template>
	</nz-form-control>
</nz-form-item>
